import Vue from 'vue'
import Component from 'vue-class-component'

/**
 * プロジェクト共通で使用する日時ユーティリティ.
 */
@Component
export class DateTime extends Vue {
    unixTimestampToShortDate(unixTimeStamp: number) {
        const date = new Date(unixTimeStamp * 1000)
        return date.toISOString().split("T")[0].replaceAll("-", "/")
    }

    unixTimestampToLongDate(unixTimeStamp: number) {
        const date = new Date(unixTimeStamp * 1000);
        return this.dateInstanceToLongDate(date)
    }

    dateInstanceToLongDate(date: Date) {
        return date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' +('0' + date.getDate()).slice(-2) + ' ' +  ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
    }
}